import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const Wrapper = styled.div<{ height: number | null }>`
  position: relative;
  height: ${({ height }) => (height === null ? "auto" : height + "px")};
  transition: height ease-in 200ms;
  overflow: hidden;
`;

const Content = styled.div`
  position: relative;
`;

interface Props {
  children: React.ReactNode;
  isOpen: boolean;
}

const Accordion = ({ isOpen, children }: Props) => {
  const [height, setHeight] = useState<number | null>(isOpen ? null : 0);

  const contentRef = useRef<HTMLDivElement | null>(null);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (!isFirstRender.current && contentRef.current) {
      if (isOpen) {
        setHeight(contentRef.current?.clientHeight);
      } else {
        setHeight(contentRef.current?.clientHeight);
        setTimeout(() => {
          setHeight(0);
        });
      }
    }

    isFirstRender.current = false;
  }, [isOpen]);

  const onTransitionEnd = () => {
    if (isOpen) {
      setHeight(null);
    }
  };

  return (
    <Wrapper height={height} onTransitionEnd={onTransitionEnd}>
      <Content ref={contentRef}>{children}</Content>
    </Wrapper>
  );
};

export default Accordion;
